import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const state = {
  isUserLogged: false,
  user: {
    name: '',
    email: '',
    token: '',
    id: ''
  },
  profile: '',
  currentProfile: '',
  redirectTo: '',

  RQRlistingFilters: {
    engagement_leader: '',
    rqr_reviewer: '',
    fiscal_year: '',
    rqr_type: '',

    advisory_id: '',
  },

  reviewslistingFilters: {
    engagement_leader: '',
    rqr_reviewer: '',
    fiscal_year: '',
    rqr_type: '',
  },

  ARRlistingFilters: {
    reference: '',
    fiscal_year: '',
    rqr_type: '',
  },
}

const store = new Vuex.Store({
  state,
  mutations,
  getters,
})

export default store
